import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RequestDownloadComponent } from "app/bundles/requests/request-download/request-download.component";
import { AuthGuard } from "app/core/auth-guard.service";
import { EditRequestInBatchComponent } from "./edit-request-in-batch/edit-request-in-batch.component";
import { EditRequestComponent } from "./edit-request/edit-request.component";
import { ListResolver } from "./list-resolver/list.resolver";
import { RequestListParentComponent } from "./request-list-parent/request-list-parent.component";
import { RequestResolverService } from "./shared/services/request-resolver.service";
import { SummaryInBatchComponent } from "./summary-in-batch/summary-in-batch.component";
import { ViewRequestComponent } from "./view-request/view-request.component";

const requestRoutes: Routes = [
  {
    path: "list",
    component: RequestListParentComponent,
    canActivate: [AuthGuard],
    resolve: { message: ListResolver },
  },
  {
    path: "spinner",
    component: RequestDownloadComponent,
  },
  {
    path: "view-request/:id",
    component: ViewRequestComponent,
    resolve: {
      request: RequestResolverService,
    },
  },
  {
    path: "edit-request/:id",
    component: EditRequestComponent,
    resolve: {
      request: RequestResolverService,
    },
  },
  {
    path: "edit-request-in-batch",
    component: EditRequestInBatchComponent,
  },
  {
    path: "summary-in-batch",
    component: SummaryInBatchComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(requestRoutes)],
  exports: [RouterModule],
})
export class RequestsRoutingModule {}
